import { render, staticRenderFns } from "./DeleteUserForBuilding.vue?vue&type=template&id=5079e054&"
import script from "./DeleteUserForBuilding.vue?vue&type=script&lang=js&"
export * from "./DeleteUserForBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports